export class FileUpload {
    public  file : File;
    public  fileType : string;
    public  userId : string ;
    public  fileCategory : string;
    public adminView : boolean;
}

export class FileUploadAddModel extends FileUpload{

}